import React, { useCallback, useEffect, useState } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, TextField, Typography, Tooltip as MuiTooltip, Backdrop, CircularProgress } from '@material-ui/core';
import { ArrowUpward, BarChartRounded, Clear, ListAlt, Pages, PictureAsPdf, PieChartRounded, Print, Remove, ShowChart, TrendingDown, TrendingFlat, TrendingUp } from '@material-ui/icons';
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Sector, Tooltip, XAxis, YAxis } from 'recharts';
import sweetAlert from '../../../f5/utils/sweetAlert';
import axios_instance from '../../../services/auth/jwt/config';
import moment from 'moment';
import { KeyboardDatePicker } from '@material-ui/pickers';

interface DashboardOrderProps {

}

const COLORS = [
    "#FF6384", // Red
    "#36A2EB", // Blue
    "#FFCE56", // Yellow
    "#4BC0C0", // Teal
    "#9966FF", // Purple
    "#FF9F40", // Orange
    "#C9CBCF", // Gray
    "#60D394", // Green
    "#F984E5", // Pink
    "#F4A261", // Light Orange
    "#2A9D8F", // Dark Teal
    "#264653"  // Dark Blue
];
// @ts-ignore
const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
                {payload.name}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
            <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
            <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.nome}`}</text>
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
                {`${value} (${(percent * 100).toFixed(2)}%)`}
            </text>
        </g>
    );
};

type Funcionario = {
    nome: string,
    id: number,
    secundarias: number,
    principais: number,
}

export default function DashboardOrder({ ...props }: DashboardOrderProps) {
    const [loading, setLoading] = useState({ is: true, message: 'Carregando' })
    const [funcionarios, setFuncionarios] = useState<Funcionario[]>([])
    const [selectedFuncionarios, setSelectedFuncionarios] = useState<number[]>([])
    const [modeDate, setModeDate] = useState<'day' | 'month'>('month')
    const [start, setStart] = useState<string>(moment().startOf('month').format('YYYY-MM-DD'))
    const [end, setEnd] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [mes, setMes] = useState(moment().month() + 1)
    const [year, setYear] = useState(moment().year())
    const [activeIndex, setActiveIndex] = useState(0);
    const [diaString, setDiaString] = useState('')
    const [dashboard, setDashboard] = useState({
        total: 0,
        lastmonth: 0,
        meses: [],
        tipos: [],
        departamentos: []
    })

    useEffect(() => {
        setLoading({ is: true, message: 'Carregando' })
        let startDate = moment().set('month', mes - 1).set('year', year).subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
        let endDate = moment().set('month', mes - 1).set('year', year).startOf('month').format('YYYY-MM-DD')
        let days = 31
        if (modeDate === 'day') {
            days = moment(end).diff(moment(start), 'days') + 1
            startDate = moment(start).subtract(days, 'days').format('YYYY-MM-DD')
            endDate = moment(start).format('YYYY-MM-DD')
        }
        axios_instance.get<{ success: boolean, graphs: any, funcionarios: Funcionario[], day_range: string }>(`ordem_servico/dashboard`, {
            params: {
                start: startDate,
                end: endDate,
                days,
                funcionarios: selectedFuncionarios.length > 0 ? selectedFuncionarios : undefined,
            }
        }).then((response) => {
            let r = response.data
            if (r.success) {
                setFuncionarios(r.funcionarios)
                setDashboard(r.graphs)
                setDiaString(r.day_range)
                if (r.graphs.tipos.length > 0) {
                    setActiveIndex(r.graphs.tipos.findIndex((item: any) => item.presente > 0) ?? 0)
                }
            }
        }).catch(() => {
            sweetAlert('error', 'Erro ao carregar inscrições')
        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }, [year, mes, selectedFuncionarios, start, end, modeDate])

    const onPrint = () => {
        window.print()
    }

    const onDownloadRelatorio = () => {
        setLoading({ is: true, message: 'Gerando Relatório...' })

        let token = localStorage.getItem('token');
        fetch(
            `https://ribasdigital.cidadeinteligente.app.br/api/ordem_servico/gerar/relatorio/ano/${year}${selectedFuncionarios.length > 0 ? `?atendente_id=${selectedFuncionarios[0]}` : ''}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            },
        )
            .then(r => r.blob())
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                a.click();
            }).finally(() => {
                setLoading({ is: false, message: '' })
            })
        /* axios_instance.get(`ordem_servico/gerar/relatorio/ano/${year}${selectedFuncionarios.length > 0 ? `?atendente_id=${selectedFuncionarios[0]}` : ''}`).then((response) => {
            // @ts-ignore
            const blob = new Blob([response.data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.click();
        }).catch(() => {
            sweetAlert('error', 'Erro ao gerar Relatorio')
        }).finally(() => {
            setLoading({ is: false, message: '' })
        }) */
    }

    // @ts-ignore
    const onPieEnter = (_, index) => {
        setActiveIndex(index);
    };

    const getSignGrowth = useCallback(() => {
        let sign = 0
        if (dashboard?.lastmonth > dashboard?.total) {
            sign = -1
        } else if (dashboard?.lastmonth < dashboard?.total) {
            sign = 1
        }
        return sign
    }, [dashboard])

    const getPorcentGrowth = useCallback(() => {
        let porcent = 0
        if (dashboard?.lastmonth === 0) {
            return '--';
        }
        if (dashboard?.lastmonth > dashboard?.total) {
            porcent = ((dashboard?.lastmonth - dashboard?.total) / dashboard?.lastmonth) * 100
        } else if (dashboard?.lastmonth < dashboard?.total) {
            porcent = ((dashboard?.total - dashboard?.lastmonth) / dashboard?.lastmonth) * 100
        }
        return porcent.toFixed(2)
    }, [dashboard])

    // @ts-ignore
    return <PageContainer>
        <Box mb={2}>
            <Typography variant="h4" component="h2">
                Dashboard
            </Typography>
        </Box>
        <Backdrop open={loading.is} style={{ zIndex: 1301, color: '#fff', flexDirection: 'column' }}>
            <CircularProgress color="inherit" />
            <Box mt={2}>{loading.message}</Box>
        </Backdrop>
        <Box mb={2}>
            <Paper style={{ padding: '0.5rem' }}>

                <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={3}>
                        <FormControl fullWidth variant='outlined'>
                            <InputLabel>Funcionários</InputLabel>
                            <Select
                                startAdornment={<IconButton onClick={() => setSelectedFuncionarios([])} >
                                    <Clear />
                                </IconButton>}
                                label="Funcionários"
                                value={selectedFuncionarios}
                                fullWidth
                                multiple
                                // @ts-ignore
                                onChange={(e) => setSelectedFuncionarios(e.target.value)}
                            >
                                {funcionarios.map((funcionario) => (
                                    <MenuItem key={funcionario.id} value={funcionario.id}>
                                        {funcionario.nome}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        {modeDate === 'month' ? <FormControl fullWidth variant='outlined'>
                            <InputLabel>Mês de Comparação</InputLabel>
                            <Select
                                label="Mês de Comparação"
                                value={mes}
                                fullWidth
                                // @ts-ignore
                                onChange={(e) => setMes(e.target.value)}
                            >
                                <MenuItem value={1}>Janeiro</MenuItem>
                                <MenuItem value={2}>Fevereiro</MenuItem>
                                <MenuItem value={3}>Março</MenuItem>
                                <MenuItem value={4}>Abril</MenuItem>
                                <MenuItem value={5}>Maio</MenuItem>
                                <MenuItem value={6}>Junho</MenuItem>
                                <MenuItem value={7}>Julho</MenuItem>
                                <MenuItem value={8}>Agosto</MenuItem>
                                <MenuItem value={9}>Setembro</MenuItem>
                                <MenuItem value={10}>Outubro</MenuItem>
                                <MenuItem value={11}>Novembro</MenuItem>
                                <MenuItem value={12}>Dezembro</MenuItem>
                            </Select>
                        </FormControl> : <KeyboardDatePicker
                            fullWidth
                            inputVariant='outlined'
                            value={moment(start)}
                            label="Data Inicial"
                            format="DD/MM/YYYY"
                            onChange={(date) => {
                                if (date) {
                                    setStart(moment(date).format('YYYY-MM-DD'))
                                    // if end is before start, set end to start + 1 day
                                    if (moment(end).isBefore(moment(date))) {
                                        setEnd(moment(date).add(1, 'days').format('YYYY-MM-DD'))
                                        // if end is after start + 62 days, set end to start + 62 days
                                    } else if (moment(end).isAfter(moment(date).add(62, 'days'))) {
                                        setEnd(moment(date).add(62, 'days').format('YYYY-MM-DD'))
                                    }
                                }
                            }}
                        />}
                    </Grid>
                    <Grid item xs={3}>
                        {modeDate === 'month' ? <TextField
                            label="Ano"
                            type="number"
                            variant="outlined"
                            value={year}
                            fullWidth
                            // @ts-ignore
                            onChange={(e) => setYear(e.target.value ? parseInt(e.target.value) : 0)}
                        /> : <KeyboardDatePicker
                            fullWidth
                            inputVariant='outlined'
                            value={moment(end)}
                            label="Data Final"
                            format="DD/MM/YYYY"
                            // disabled dates before start date and after 62 days from start date
                            shouldDisableDate={(day) => {
                                if (start) {
                                    const startDate = moment(start);
                                    const maxDate = startDate.clone().add(62, 'days');
                                    return moment(day).isBefore(startDate) || moment(day).isAfter(maxDate);
                                }
                                return false;
                            }}
                            onChange={(date) => {
                                if (date) {
                                    setEnd(moment(date).format('YYYY-MM-DD'))
                                }
                            }}
                        />}
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            variant='contained'
                            color={modeDate === 'month' ? "primary" : "secondary"}
                            fullWidth
                            onClick={() => setModeDate((prev) => prev === 'day' ? 'month' : 'day')}
                        >
                            Filtrar por {modeDate === 'day' ? 'Mês' : 'Dia'}
                        </Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Box display="flex" justifyContent="flex-end" alignItems="center" style={{ gap: '0.5rem' }}>
                            <MuiTooltip title="Baixar Relatório">
                                <Button variant="contained" color="primary" onClick={onDownloadRelatorio}>
                                    <PictureAsPdf />
                                </Button>
                            </MuiTooltip>
                            <Button variant="contained" color="primary" onClick={onPrint}>
                                <Print />
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper>
                    <Box p={2}>
                        <Box mb={3} display="flex" alignItems="center">
                            <ShowChart />
                            <Box ml={1} fontWeight={700}>
                                Fluxo De Ordens de Serviço
                            </Box>
                        </Box>
                        <Box>
                            <ResponsiveContainer width="100%" height={300}>
                                <AreaChart data={dashboard?.meses} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                                    <XAxis dataKey="dia" />
                                    <YAxis />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <Tooltip
                                        labelStyle={{ color: 'black' }}
                                        itemStyle={{ color: 'black' }}
                                        cursor={false}
                                        formatter={(value, name, entry) => {
                                            if (name.toLowerCase().includes('anterior')) {
                                                return `${value} (${entry.payload.anterior_title})`
                                            }
                                            return `${value} (${entry.payload.atual_title})`
                                        }}
                                    />
                                    <Legend />
                                    <defs>
                                        <linearGradient id="colorCurrent" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#f7aa1b" stopOpacity={0.8} />
                                            <stop offset="95%" stopColor="#f7aa1b" stopOpacity={0} />
                                        </linearGradient>
                                        <linearGradient id="colorLast" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#a19b91" stopOpacity={0.8} />
                                            <stop offset="95%" stopColor="#a19b91" stopOpacity={0} />
                                        </linearGradient>
                                    </defs>
                                    <Area
                                        type="monotone"
                                        dataKey="anterior"
                                        name="Mês Anterior"
                                        stroke="#a19b91"
                                        fill="url(#colorLast)"
                                        fillOpacity={1}
                                    />
                                    <Area
                                        type="monotone"
                                        dataKey="atual"
                                        name="Mês Atual"
                                        stroke="#f7aa1b"
                                        fill="url(#colorCurrent)"
                                        fillOpacity={1}
                                    />
                                </AreaChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper>
                    <Box p={2}>
                        <Box mb={3} display="flex" alignItems="center">
                            <BarChartRounded />
                            <Box ml={1} fontWeight={700}>
                                Ordens por Funcionário
                            </Box>
                        </Box>
                        <Box>
                            <ResponsiveContainer width="100%" height={400}>
                                <BarChart data={funcionarios} layout='horizontal'>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <YAxis type="number" />
                                    <XAxis
                                        dataKey="nome"
                                        type="category"
                                        width={200}
                                        tickFormatter={(value) => {
                                            return `${value.split(' ')[0]} ${value.split(' ')?.[1]?.charAt(0).toUpperCase() ?? ''}`
                                        }}
                                    />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="principais" label={{ position: 'top' }} name="Principal" fill="#f7aa1b" stackId="A"
                                        background={(props) => {
                                            if (selectedFuncionarios.includes(props.id)) {
                                                return <rect x={props.x} y={props.y} width={props.width} height={props.height} fill="#a1fb9133" rx={5} ry={5} />
                                            }
                                            return false
                                        }}
                                    />
                                    <Bar dataKey="secundarias" label={{ position: 'top' }} name="Secundário" fill="#a19b91" stackId="A" />
                                </BarChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={10}>
                <Paper>
                    <Box p={2}>
                        <Box mb={3} display="flex" alignItems="center">
                            <PieChartRounded />
                            <Box ml={1} fontWeight={700}>
                                Ordens de Serviço por Tipo
                            </Box>
                        </Box>
                        <Box>
                            <ResponsiveContainer width="100%" height={400}>
                                <PieChart width={400} height={400}>
                                    <Legend verticalAlign="middle" align="right" layout="vertical" />
                                    <Pie
                                        activeIndex={activeIndex}
                                        onMouseEnter={onPieEnter}
                                        activeShape={renderActiveShape}
                                        data={dashboard?.tipos}
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={150}
                                        fill="#8884d8"
                                        dataKey="presente"
                                        nameKey="nome"
                                    >
                                        {dashboard?.tipos.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={2}>
                <Paper>
                    <Box p={2}>
                        <Box mb={3} display="flex" alignItems="center">
                            <ListAlt />
                            <Box ml={1} fontWeight={700}>
                                Total de Ordens (do dia {diaString})
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" height="100%">
                            <Typography variant="h1" component="h2" color="primary">
                                {dashboard?.total ?? '0'}
                            </Typography>
                            <Typography variant="h5" component="h4" color="primary">
                                Ordens do mês atual
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" height="100%" mt={2}>
                            <Typography variant="h1" component="h2" color="secondary">
                                {dashboard?.lastmonth ?? '0'}
                            </Typography>
                            <Typography variant="h5" component="h4" color="secondary">
                                Ordens do mês anterior
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" height="100%" mt={2}>
                            <Box display="flex" justifyContent="center" alignItems="center" flexDirection="row">
                                {getSignGrowth() === 0 ? <TrendingFlat /> : getSignGrowth() > 0 ? <TrendingUp color="primary" /> : <TrendingDown color="secondary" />}
                                <Typography variant="h1" component="h2" color={getSignGrowth() > 0 ? 'primary' : 'secondary'} style={{ marginLeft: 5 }}>
                                    {getPorcentGrowth()}%
                                </Typography>
                            </Box>
                            <Typography variant="h5" component="h4" style={{ textAlign: "center" }}>
                                Crescimento em relação ao mês anterior (%)
                            </Typography>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    </PageContainer >
}